import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionTargetKind as r } from "../types/HostActionTarget.mjs";
//#region src/mappers/toCalendarFeedActions.ts
var i = (i, a) => i.filter((e) => e.status !== "active").map((i) => {
	let o = a.get(i.listing_id);
	return {
		id: `${e.CalendarFeedFailing}:${i.id}`,
		type: e.CalendarFeedFailing,
		intent: t.Blocker,
		imageUrl: o?.image ?? void 0,
		params: {
			variant: i.status,
			count: i.consecutive_failures
		},
		object: o?.listing_title ?? void 0,
		facets: i.last_error ? [{
			kind: n.Text,
			text: i.last_error
		}] : void 0,
		createdAt: i.last_success_at ?? i.created_at,
		target: {
			kind: r.PropertyCalendarSync,
			id: o?.property_id
		}
	};
});
//#endregion
export { i as toCalendarFeedActions };
